import React from 'react'
import { Field } from 'formik'
import { Input } from '@wellbeingxltd/fe-lib/components'
import styles from '../Shopify.module.scss'

export const Step = ({
    image = null,
    images = null,
    html = null,
    step = null,
    text = '',
    textWithTable = null,
    anotherTexts = null,
    completedStep,
    onChange,
    initialValues = null,
    integrationComplete = false,
}) => (
    <div className={styles.Step}>
        <div className={styles.inputBlock}>
            {step && (
                <Input
                    id={step}
                    className={styles.checkbox}
                    type="checkbox"
                    checked={step <= completedStep || integrationComplete}
                    disabled={integrationComplete}
                    onChange={event => onChange(event, step)}
                />
            )}
            {html ? (
                <div
                    dangerouslySetInnerHTML={{
                        __html: `<p className=${styles.text}>
                            ${step ? `<b>Step ${step}. </b>` : ''}
                            ${html}
                        </p>`,
                    }}
                ></div>
            ) : (
                <p className={styles.text}>
                    {step && <b>Step {step}. </b>}
                    {text}
                </p>
            )}
        </div>
        {image && <img className={styles.image} src={image} alt="" />}
        {images && images.map((image, index) => <img key={index} className={styles.image} src={image} alt="" />)}
        {textWithTable && (
            <>
                <h3 className={styles.h3}>{textWithTable.heading}</h3>
                {textWithTable.table}
            </>
        )}
        {anotherTexts &&
            anotherTexts.map(({ html = null, text = null, image = null }, index) => (
                <ul key={index}>
                    {html ? (
                        <div dangerouslySetInnerHTML={{ __html: `<li className=${styles.text}>${html}</li>` }}></div>
                    ) : (
                        <li className={styles.text}>{text}</li>
                    )}
                    {image && <img className={styles.image} src={image} alt="" />}
                </ul>
            ))}
        {initialValues && (
            <>
                <Field name="shopifyApiKey">
                    {({ field, meta }) => (
                        <Input
                            {...field}
                            id="shopifyApiKey"
                            type="text"
                            autoComplete="off"
                            touched={meta.touched}
                            error={meta.error}
                            labelAbove="API key"
                            disabled={initialValues?.shopifyApiKey.length}
                        />
                    )}
                </Field>
                <Field name="shopifyAccessToken">
                    {({ field, meta }) => (
                        <Input
                            {...field}
                            id="shopifyAccessToken"
                            type="new-password"
                            autoComplete="off"
                            touched={meta.touched}
                            error={meta.error}
                            labelAbove="Admin API access token"
                            disabled={initialValues?.shopifyAccessToken.length}
                        />
                    )}
                </Field>
            </>
        )}
        {initialValues && (
            <Field name="shopifyStoreDomain">
                {({ field, meta }) => (
                    <Input
                        id="shopifyStoreDomain"
                        type="text"
                        touched={meta.touched}
                        error={meta.error}
                        {...field}
                        labelAbove="Shopify Store Domain"
                    />
                )}
            </Field>
        )}
    </div>
)
